export default "__VITE_ASSET__BOdBx9hc__"